require([
    "SearchFilters/searchFilters"
],
    function (searchFilters) {      
        searchFilters.init();
    });

define("SearchFilters/main", function(){});

